import { NgClass, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { NoPaymentMethodDialogComponent } from '@shared/components/no-payment-method-dialog/no-payment-method-dialog.component';
import { SuggestedAuctionsComponent } from '@shared/components/suggested-auctions/suggested-auctions.component';
import { NgxMaskDirective } from 'ngx-mask';
import { TagsComponent } from './../shared/components/tags/tags.component';
import { ArticleRoutingModule } from './article-routing.module';
import { ArticleComponent } from './article.component';
import { ArticleBidComponent } from './components/article-bid/article-bid.component';
import { ArticleDescriptionComponent } from './components/article-description/article-description.component';
import { ArticleGalleryComponent } from './components/article-gallery/article-gallery.component';
import { ArticlePropertiesComponent } from './components/article-properties/article-properties.component';
import { AuctionTypeInfoDialogComponent } from './components/dialogs/auction-type-info-dialog/auction-type-info-dialog.component';
import { AutobidDialogComponent } from './components/dialogs/autobid-dialog/autobid-dialog.component';
import { BidBuyNowDialogComponent } from './components/dialogs/bid-buy-now-dialog/bid-buy-now-dialog.component';
import { BidReservePriceComponent } from './components/dialogs/bid-reserve-price/bid-reserve-price.component';
import { BidSuccessDialogComponent } from './components/dialogs/bid-success-dialog/bid-success-dialog.component';
import { DeleteAutobidDialogComponent } from './components/dialogs/delete-autobid-dialog/delete-autobid-dialog.component';
import { DirectOfferMadeDialogComponent } from './components/dialogs/direct-offer-made-dialog/direct-offer-made-dialog/direct-offer-made-dialog.component';
import { EmailSentDialogComponent } from './components/dialogs/email-sent-dialog/email-sent-dialog.component';
import { MessageToComponent } from './components/message-to/message-to.component';
import { ShippingWarningComponent } from './components/shipping-warning/shipping-warning.component';

@NgModule({
  declarations: [
    AuctionTypeInfoDialogComponent,
    AutobidDialogComponent,
    BidBuyNowDialogComponent,
    DeleteAutobidDialogComponent,
    BidSuccessDialogComponent,
    BidReservePriceComponent,
    EmailSentDialogComponent,
    MessageToComponent,
    DirectOfferMadeDialogComponent,
  ],
  imports: [
    ArticleComponent,
    ArticleRoutingModule,
    NgIf,
    FaIconComponent,
    FormsModule,
    NgClass,
    TranslatePipe,
    NgxMaskDirective,
    SuggestedAuctionsComponent,
    TagsComponent,
    NoPaymentMethodDialogComponent,
    ArticleGalleryComponent,
    ArticleBidComponent,
    ArticleDescriptionComponent,
    ArticlePropertiesComponent,
    ShippingWarningComponent,
  ],
  exports: [],
})
export class ArticleModule {}
